module.exports = __webpack_public_path__ + "static/media/icon-present-text.a36fc101.png";